import dayjs from "dayjs";

export const dateMask = (dateString) => {
  const date = dayjs(dateString);
  return date.format("DD/MM/YYYY");
};

export const dateTimeMask = (dateString, showYear = true) => {
  const date = new Date(dateString);
  let hours = date.getHours();
  hours = ("0" + hours).slice(-2);

  let minutes = date.getMinutes();
  minutes = ("0" + minutes).slice(-2);

  if (showYear === true)
    return `${date.getDate()}/${
      date.getMonth() + 1
    }/${date.getFullYear()} - ${hours}:${minutes}`;
  else return `${date.getDate()}/${date.getMonth() + 1} - ${hours}:${minutes}`;
};

export const timeMask = (dateString) => {
  const date = new Date(dateString);
  let hours = date.getHours();
  hours = ("0" + hours).slice(-2);

  let minutes = date.getMinutes();
  minutes = ("0" + minutes).slice(-2);

  return `${hours}:${minutes}`;
};

export const elapsedTimeMask = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const elapsedMilliseconds = now - date;

  const seconds = Math.floor(elapsedMilliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days} dia${days > 1 ? "s" : ""}`;
  } else if (hours > 0) {
    return `${hours} hora${hours > 1 ? "s" : ""}`;
  } else if (minutes > 0) {
    return `${minutes} min${minutes > 1 ? "s" : ""}`;
  } else {
    return "Agora";
  }
};

export const formatDateForInputTypeDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
